import React from 'react'

import { Dialog } from 'primereact/dialog'

import DialogFooter from '../../dialogFooter'
import ConstantsUtil from '../../../context/constantsUtil'
import HandleErrorService from '../../../app/service/handleErrorService'
import * as popUp from '../../toastr'
import GeneralServices from '../../../app/service/generalServices'
import CheckBoxComponent from '../../relatorios/checkBoxComponent'
import CadastroProdutoService from '../../../app/service/central/cadastroProdutoService'
import InputChooseTipoDreCompetencia from '../../contasAPagar/inputChooseTipoDreCompetencia'

class CreateOrUpdateTipoProdutoDialog extends React.Component {

    constructor(){
        super()
        this.cadastroProdutoService = new CadastroProdutoService()
    }

    state = {

        tipoDeProduto: {},
        inputErrorClass: '',
        inputTipoDreCompetenciaErrorClass: '',

    }

    componentDidUpdate(){
        this.setStates()
    }

    setStates = () => {
        if( (this.props.visible && !this.state.didUpdated) || this.props.forceUpdate ){

            this.resetView()

            if(this.props.tipoDeProduto){
                this.setState({tipoDeProduto: this.props.tipoDeProduto})
                }
            else(
                this.setState({tipoDeProduto: {}})
            )

                
            this.setState({didUpdated: true})
            if(this.props.doneForceUpdate){
                this.props.doneForceUpdate()
            }
        }
    }

    resetView = () => {
        this.setState({
            inputErrorClass: '',
            inputTipoDreCompetenciaErrorClass: '',
        })
    }

    handleChange = async event => {
        let tipoDeProduto = this.state.tipoDeProduto
        tipoDeProduto.descricao = event.target.value
        await this.setState({tipoDeProduto})
    }

    handleChangeCompoeCmv = cmv => {
        let tipoDeProduto = this.state.tipoDeProduto
        tipoDeProduto.cmv = cmv
        this.setState({tipoDeProduto})
    }

    hideDialog = async () => {
        await this.setState({didUpdated: false})
        this.props.hideDialog()
    }

    checkData = () => {
        
        let check = true
        
        if(!this.state.tipoDeProduto || !this.state.tipoDeProduto.descricao){
            check = false
            this.setState({inputErrorClass: ConstantsUtil.bootstrapInputErrorClass})
        }
        
        if(this.state.tipoDeProduto && !this.state.tipoDeProduto.tipoDreCompetencia){
            check = false
            this.setState({inputTipoDreCompetenciaErrorClass: ConstantsUtil.bootstrapInputErrorClass})
        }

        return check

    }

    callSave = () => {
        this.resetView()
        if(this.checkData()){
            this.save()
        }
    }

    handleSave = () => {

        /*
            O tipoProduto do state na verdade pode ser:
            - Tipo de Produto
            - Tipo de Estoque
        */

        switch(this.props.tipo){
            
            case ConstantsUtil.inputTipoProduto:
                return this.cadastroProdutoService.saveTipoProduto(this.state.tipoDeProduto)
            
            case ConstantsUtil.inputTipoEstoque:
                return this.cadastroProdutoService.saveTipoEstoque(this.state.tipoDeProduto)
        }
    }

    save = () => {
        this.handleSave()
        .then(response => {
            this.hideDialog()
            popUp.successPopUp("Salvo com sucesso!")
            if(this.props.search){
                this.props.search()
            }
        })
        .catch(error => 
            HandleErrorService.handleError(error)
        )
    }

    handleSelectionTipoDreCompetenciaChange = (selectedTipoDreCompetencia) => {
        // console.log("selectedTipoDreCompetencia: ", selectedTipoDreCompetencia)
        let tipoDeProduto = this.state.tipoDeProduto
        tipoDeProduto.tipoDreCompetencia = selectedTipoDreCompetencia
        this.setState({tipoDeProduto})
    }

    render(){

        const dialogFooter = (
            <DialogFooter save = {this.callSave} hideDialog = {this.hideDialog}/>
        )

        const renderTipoDreCompetencia = () => {
            // console.log("this.props.tipo: ", this.props.tipo)
            if(this.props.tipo === ConstantsUtil.inputTipoProduto){
                return(
                    <InputChooseTipoDreCompetencia
                        selectedTipoDreCompetenciaLabel={this.state.tipoDeProduto?.tipoDreCompetencia?.descricao}
                        handleSelectionTipoDreCompetenciaChange={this.handleSelectionTipoDreCompetenciaChange}
                        inputErrorClass={this.state.inputTipoDreCompetenciaErrorClass}
                    />                    
                )

            }
        }

        return(
            <>
                <Dialog
                    header={this.props.isEdit ? GeneralServices.getEditarTipoProdutoOuEstoqueLabel(this.props.tipo) : GeneralServices.getCadastrarTipoProdutoOuEstoqueLabel(this.props.tipo)}
                    visible={this.props.visible}
                    modal = {true}
                    style={{ width: '350px' }}
                    footer={dialogFooter}
                    onHide={this.hideDialog}
                >
                    <div className="p-field">
                        <label>{GeneralServices.getTipoDeProdutoOuEstoqueLabel(this.props.tipo)}</label>
                        <input
                            type="text"
                            autoFocus
                            className={"form-control " + this.state.inputErrorClass}
                            value = {this.state.tipoDeProduto.descricao}
                            onChange={this.handleChange}
                        />    
                        <div className="invalid-feedback">{"Informe o nome do tipo de produto"}</div>
                    </div>

                    <br />

                    {renderTipoDreCompetencia()}

                </Dialog>            
            </>
        )
    }

}

export default CreateOrUpdateTipoProdutoDialog